import { useMemo } from 'react'
import { useStoreAttributeValues } from '@/hooks/useStoreAttributes'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { MultiSelect } from '@/components/ui/multi-select'

interface StoreAttributeValueSelectProps {
  fieldName: string
  value: string | string[]
  onChange: (value: string | string[]) => void
  multiple: boolean
}

export function StoreAttributeValueSelect({
  fieldName,
  value,
  onChange,
  multiple,
}: StoreAttributeValueSelectProps) {
  const { data, isLoading } = useStoreAttributeValues(fieldName)

  const options = useMemo(
    () =>
      (data?.values ?? []).map(v => ({
        value: v,
        label: v,
      })),
    [data?.values]
  )

  if (multiple) {
    const arrValue = Array.isArray(value) ? value : value ? [value] : []
    return (
      <MultiSelect
        options={options}
        value={arrValue}
        onValueChange={onChange}
        placeholder="Select values..."
        isLoading={isLoading}
        className="flex-1"
      />
    )
  }

  const strValue = Array.isArray(value) ? (value[0] ?? '') : (value ?? '')

  return (
    <Select value={strValue} onValueChange={v => onChange(v)}>
      <SelectTrigger className="flex-1">
        <SelectValue
          placeholder={isLoading ? 'Loading...' : 'Select value...'}
        />
      </SelectTrigger>
      <SelectContent>
        {options.map(o => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
